export default "__VITE_ASSET__ibD$Pa9E__"